<i18n>
{
	"en": {
		"freeText": "Free text",
		"noFreeText": "There are no free texts yet.",
		"invoice": "Invoice",
		"waybill": "Waybill",
		"loadingList": "Loading list",
		"internal": "Internal",
		"goodsList": "Goods list"
	},
	"no": {
		"freeText": "Fritekst",
		"noFreeText": "Det er ingen fritekster ennå.",
		"invoice": "Faktura",
		"waybill": "Fraktbrev",
		"loadingList": "Lasteliste",
		"internal": "Internt",
		"goodsList": "Godsliste"
	}
}
</i18n>

<template>
	<div class="free-text-sub-order">

		<MultipleTextAreas
			:textAreas="textAreas"
			:disabled="orderIsLocked"

			@textAreaChange="setSubOrderFreeText({ key: $event.key, freeText: $event.value })"
		/>
	</div>
</template>

<script>
import {
	mapMutations, mapGetters
} from '../store/newOrder.store';
import MultipleTextAreas from '@/modules/newOrder/common/MultipleTextAreas';

export default {
	name: 'FreeTextSubOrder',
	components: { MultipleTextAreas },
	props: {
		selectedSubOrder: Object,
	},
	computed: {
		...mapGetters(['orderIsLocked']),

		textAreas() {
			return [
				{
					key: 'transporterInstructions',
					value: this.subOrder.transporterInstructions,
					name: this.$t('waybill')
				},
				{
					key: 'invoiceFreeText',
					value: this.subOrder.invoiceFreeText,
					name: this.$t('invoice')
				},
				{
					key: 'loadingListFreeText',
					value: this.subOrder.loadingListFreeText,
					name: this.$t('loadingList')
				},
				{
					key: 'internalNotes',
					value: this.subOrder.internalNotes,
					name: this.$t('internal')
				},
				{
					key: 'goodsListFreeText',
					value: this.subOrder.goodsListFreeText,
					name: this.$t('goodsList')
				}
			];
		},

		subOrder() {
			return this.selectedSubOrder;
		}
	},
	methods: {
		...mapMutations(['setSubOrderFreeText']),
	}
};
</script>

<style lang="scss" scoped>

.free-text-sub-order {
	height: 100%;
	width: 100%;
	min-height: inherit;
}

</style>
